import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Theme store for dark mode persistence
 * Implements Requirement 197 AC 2: Dark mode support with persistence
 */

interface ThemeState {
  darkMode: boolean;
  toggleDarkMode: () => void;
  setDarkMode: (enabled: boolean) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      darkMode: false,
      toggleDarkMode: () =>
        set((state) => {
          const newDarkMode = !state.darkMode;
          if (newDarkMode) {
            document.documentElement.classList.add('dark');
          } else {
            document.documentElement.classList.remove('dark');
          }
          return { darkMode: newDarkMode };
        }),
      setDarkMode: (enabled: boolean) =>
        set(() => {
          if (enabled) {
            document.documentElement.classList.add('dark');
          } else {
            document.documentElement.classList.remove('dark');
          }
          return { darkMode: enabled };
        }),
    }),
    {
      name: 'theme-storage',
    }
  )
);
